<template>    
  <div
    class="results-table__cell"
    :title="cellValue"
  >
    {{ cellValue | formatDate }}
  </div>
</template>

<script>
import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins],

  computed: {
    cellValue() {
      return this.docData[this.cellData.dataFields[0]]
    }
  }
};
</script>
